import React from 'react';
import { Typography } from '@mui/material';
import { CategoryList } from '../components/CategoryList';

export const CategoriesPage: React.FC = () => {
    document.title = "Duitleh - Categories";
    return (
        <>
            <Typography variant="h4" gutterBottom>
                Categories
            </Typography>
            <CategoryList />
        </>
    );
};
